import classNames from "classnames";
import { useLocalStorage } from "react-use";

const SlideBarcode = ({
  barcode_image_url,
  macro_image_url,
  topLeft,
}: {
  barcode_image_url?: string;
  macro_image_url?: string;
  topLeft?: boolean;
}) => {
  const [zoomed, setZoomed] = useLocalStorage<boolean>("barcodeZoomed", false);
  return (
    <div
      className={classNames(
        "Barcode",
        zoomed ? "Barcode--lg" : "Barcode--sm",
        topLeft && "Barcode--topLeft"
      )}
      onClick={() => setZoomed(!zoomed)}
      data-testid="barcode-macro"
    >
      {barcode_image_url ? (
        barcode_image_url !== "MISSING" ? (
          <figure>
            <img src={barcode_image_url} alt="" />
          </figure>
        ) : (
          <div className="missing_barcode">BARCODE MISSING</div>
        )
      ) : (
        <></>
      )}
      {macro_image_url ? (
        macro_image_url !== "MISSING" ? (
          <figure>
            <img src={macro_image_url} alt="" />
          </figure>
        ) : (
          <div className="missing_macro">
            <p>MACRO</p>
            <p>IMAGE</p>
            <p>MISSING</p>
          </div>
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default SlideBarcode;
